import request from "@/utils/request";
export function articAudit(id) {
  return request({
    url: "/api/article/audit/" + id,
    method: "PUT",
  });
}
